import * as types from '../constants/actionTypes';
import objectAssign from 'object-assign';
import initialState from './initialState';

// IMPORTANT: Note that with Redux, state should NEVER be changed.
// State is considered immutable. Instead,
// create a copy of the state passed and set new values on the copy.
// Note that I'm using Object.assign to create a copy of current state
// and update values on the copy.
export default function userReducer(state = initialState.reports, action) {
  let newState;

  switch (action.type) {
    case types.LOAD_REPORT_DETAILS:
      newState = objectAssign({}, state, {loading: true});
      newState.ajaxRequests = newState.ajaxRequests + 1;
      return newState;

    case types.LOAD_REPORT_DETAILS_SUCCESS:
      newState = objectAssign({}, state, {loading: false});
      newState.pivotDetails = action.details;
      newState.detailsUpdated = action.detailsUpdated;
      newState.ajaxRequests = newState.ajaxRequests - 1;
      return newState;

    // case types.LOAD_TEAM_DETAILS_SUCCESS:
    //   newState = objectAssign({}, state, {loading: false});
    //   newState.teamDetails = objectAssign({}, newState.teamDetails);
    //   newState.teamDetails[action.teamSlug] = action.details;
    //   newState.teamDetailsUpdated = action.detailsUpdated;
    //   newState.ajaxRequests = newState.ajaxRequests - 1;
    //   return newState;

    case types.LOAD_TEAMS_DETAILS_SUCCESS:
      newState = objectAssign({}, state, {loading: false});
      newState.teamsData = action.details;
      newState.teamDetailsUpdated = action.detailsUpdated;
      newState.ajaxRequests = newState.ajaxRequests - 1;
      return newState;

    case types.LOAD_REPORT_DATA_SUCCESS:
      newState = objectAssign({}, state, {loading: false});
      newState.reportData = action.details;
      newState.ajaxRequests = newState.ajaxRequests - 1;
      return newState;

    case types.LOAD_REPORT_DETAILS_FAILURE:
      newState = objectAssign({}, state, {loading: false});
      newState.ajaxRequests = newState.ajaxRequests - 1;
      return newState;

    default:
      return state;
  }
}



/** WEBPACK FOOTER **
 ** ./src/reducers/reportReducer.js
 **/